import Vue from 'vue'

export const netword = Vue.directive('network', {
  inserted(el, binding) {
    window.addEventListener('offline', () => {
      // 当网络断开时触发的逻辑
      console.log("网络已断开")

      if (typeof binding.value === "function") {
        binding.value('notWork') // 如果有传入函数作为参数，则调用该函数
      }
    })

    window.addEventListener('online', () => {
      // 当网络连接上线后触发的逻辑
      console.log("网络已连接")

      if (typeof binding.value === "function") {
        binding.value('link') // 如果有传入函数作为参数，则调用该函数
      }
    })
  },

  unbind(el) {
    window.removeEventListener('offline')
    window.removeEventListener('online')
  }
})



// WEBPACK FOOTER //
// ./src/directives/netWork.js